export default {"src":"/_next/static/image/public/logos/coinbase-icon.f27c5fe2e946feb655140b6d437f9744.svg","height":47,"width":46};